module.exports = __webpack_public_path__ + "img/f10550f.png";